import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";

import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import EnquiryModal from "../../../models/enquiries.modal"
import subadminsModal from "models/subadmins.modal";





const QualifiedEnquiriesViewPage = () => {
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();
  

  const getListData = async () => {
    setIsLoading(true);
    await EnquiryModal
    .detail(parmas.id)
      .then((result) => {
      
        setIsLoading(false);
        if (result) {
          setDataList(result);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListData();
  }, [location, parmas.mid]);

  const [allStudentget, setAllStudentGet] = useState("");
  const getListDataAllStudent = async () => {
    setIsLoading(true);
    await enquiriesModal
      .parentStudentget(parmas.id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setAllStudentGet(result.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListDataAllStudent();
  }, [location, parmas.id]);

  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };
  const item = "";

  const handleSubmiteditParentDetails = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("mobile", dataList?.userData?.username);
    // You can adjust the header configuration according to your API requirements
    enquiriesModal
      .editParentDeatils(form)
      .then((response) => {
        getListData();
        toggleModal();
        helper.sweetalert.toast(response.data.message, "success");
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };

  const [selectedGender, setSelectedGender] = useState("");

  const [selectedMode, setSelectedMode] = useState("");

  useEffect(() => {
    if (dataList?.gender) {
      setSelectedGender(dataList.gender);
      setSelectedMode(dataList.mode);
    }
  }, [dataList]);

  const handleChangegender = (event) => {
    setSelectedGender(event.target.value);
  };
  const handleChangeMode = (event) => {
    setSelectedGender(event.target.value);
  };




  const handleDel = async (id) => {
    const data = {
      id: parmas.id,
      sid: id,
    };

    helper.sweetalert
      .confirm("Are you sure you want to delete this student", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          enquiriesModal.deleteStudent(data).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListDataAllStudent();
          });
        }
      });
  };

  
  const [allTutors, setAllTutors] = useState();
  const getListDataAllTutors = async () => {
    const data = {
      page: "1",
      size: "1000000000000",
    };
    setIsLoading(true);
    await subadminsModal
      .Getlist(data)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setAllTutors(result.data.data);
        }
      })
      .catch((error) => {
        setCurrentPage("");
        setPerPage("");
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getListDataAllTutors();
  }, [location]);
 

  const [formData, setFormData] = useState({
    status:"Qualified Enquiry",
    class_type: "",
    //id:parmas.id,
    assigned_to_id: "",
    remark: "",
    tutor_remark: [],
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

 

  const navigate = useNavigate();
// change enquries 
  const EnquriesStatusChange = (event) => {
    event.preventDefault();

    const form= new FormData(event.target)
    form.append("status","qualified_enq");
   
   

   
    EnquiryModal
     .qualified(parmas.id, form)
     .then((response) => {
      
      helper.sweetalert.toast(response.data.message, "success");
      navigate(-1);
     })
     .catch((error) => {
       helper.sweetalert.toast(error?.response?.data?.message, "error");
      });
  };
console.log("data list 5",dataList)
  return (
    <>
      <Container className="pt-7">
        <Card className="w-100" style={{ borderRadius: ".5rem" }}>
          <CardHeader
            className="p-2 ml-3"
            style={{ color: "black", fontWeight: "bold" }}
          >
            Parent Basice Detailsss{" "}
          </CardHeader>
          <div className="shadow-sm" style={{ backgroundColor: "#f5f5f5" }}>
            <CardBody className="p-0 pl-4">
              <Row>
                <Col size="3">
                  {/* <div className="top-card-div"> */}
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      {" "}
                      <span style={{ color: "#999896" }}>Parent Name -</span>
                      {/* - {employeeDetails?.designation} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {`${dataList?.userData?.first_name} ${dataList?.userData?.last_name}`}
                      </p>
                    </p>
                  </div>
                  {/* </div> */}
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      <span style={{ color: "#999896" }}>Mobile no -</span>{" "}
                      {/* - {employeeDetails?.roleName} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                       {dataList?.userData?.username}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p>
                      <span style={{ color: "#999896" }}>Gender -</span>{" "}
                      {/* - {employeeDetails?.roleName} */}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {" "}
                        {dataList?.userData?.gender || "Not Filled"}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div
                    style={{
                      lineHeight: "13px",
                      paddingTop: "15px",
                    }}
                  >
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>Email Address -</span>{" "}
                      <br />{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.userData?.email}
                      </p>
                      {/* {employeeDetails?.parent_department_name}{" "} */}
                    </p>
                  </div>
                </Col>
              </Row>

              <hr className="mt-0 mb-4" />
              <Row>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>
                        Mode of Tuition -
                      </span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.userData?.parentData?.modeOfTution
                        }
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>Location -</span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {dataList?.userData?.parentData?.location

                        }
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>State -</span> <br />{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                        {" "}
                        {dataList?.userData?.parentData?.state

}
                      </p>
                      {/* {employeeDetails?.parent_department_name}{" "} */}
                    </p>
                  </div>
                </Col>
                <Col size="3">
                  <div className="top-card-div">
                    <p className="card-text">
                      <span style={{ color: "#999896" }}>City -</span>{" "}
                      <p style={{ color: "black", fontWeight: "bold" }}>
                      {dataList?.userData?.parentData?.city

}
                      </p>
                      {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="mt-0" />
            </CardBody>
            <Row className="mb-2">
              <Col md={12}>
                <Button
                  type="submit"
                  // style={{ float: "right", marginTop: "20px" }}
                  onClick={toggleModal}
                  style={{
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    float: "right",
                    marginRight: "20px",
                  }}
                >
                  Edit
                </Button>
              </Col>
            </Row>
          </div>
        </Card>
        {true && (
          <Row>
            <div className="col mt-3">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Students List</h3>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Student NAME</th>
                      <th scope="col">Academic</th>
                      <th scope="col">Board</th>
                      <th scope="col">Class</th>
                      <th scope="col">Subject</th>

                      <th scope="col">Gender</th>
                      <th scope="col">Date of Birth</th>
                      <th scope="col"> School/College/University Name</th>
                      <th scope="col">Preferred Time Duration</th>
                      <th scope="col">Tuition Tenure</th>
                      <th scope="col">Location Preference</th>
                      {/* <th scope="col"> Enquiry For</th> */}
                      <th scope="col"> Loaction City</th>
                      <th scope="col"> Tutors Level</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  {true && (
                    <tbody>
                      {allStudentget?.length > 0 ? (
                        allStudentget?.map((item, index) => {
                          return (
                            <tr key={item.id} style={{ cursor: "pointer" }}>
                              <td>{index + 1}</td>
                              <td>{item?.name || "-"}</td>
                              <td>{item?.Academic || "-"}</td>
                              <td>{item?.Board || "-"}</td>
                              <td>{item?.Class || "-"}</td>
                              <td>
                                {item?.subjects?.map((item) => item) || "-"}
                              </td>
                              <td>{item?.gender || "-"}</td>
                              <td> {item?.dob || "-"}</td>
                              <td>{item?.school_name || "-"}</td>
                              <td>{item?.preferrd_time || "-"}</td>
                              <td>{item?.term || "-"}</td>
                              <td>{item?.location || "-"}</td>
                              {/* <td  >{item?.Enquiry_For || "Student"}</td> */}
                              <td>{item?.city || "-"}</td>
                              <td>{item?.tutor_level || "-"}</td>
                              <td
                                className="pl-4 p-0"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // justifyContent: "center",
                                  // alignItems: "center",
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="top"
                                  target="eyeTooltips"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  id="eyeTooltips"
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  tag={Link}
                                  to={`/admin/viewenquiry/EditEnquriParentDetails/${parmas.mid}/${parmas.id}/${item.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target="userTooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    marginTop: "10px",
                                    // backgroundColor: "#f5f5f5",
                                    display: "inline-block",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "20%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                                  onClick={() => handleDel(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="6" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </Table>
              </Card>
            </div>
          </Row>
        )}

        <Card className="w-100 mt-3" style={{ borderRadius: ".5rem" }}>
          <Row className="g-0">
            <Col md="12">
              <CardBody className="p-4">
                <Form onSubmit={EnquriesStatusChange}>
                  <Row>
                    <Col md={6}>
                      <Label>Type of Class</Label>
                      <Input
                        id="forType"
                        type="select"
                        name="class_type"
                        required
                       // value={formData.class_type}
                       // onChange={handleChange}
                      >
                        <option value="">Select Class Type</option>
                        <option value="SEPARATE">Separate Class</option>
                        <option value="Combined">Combined Class</option>
                        <option value="SME">SME</option>
                      </Input>
                    </Col>
                    <Col md={6}>
                      <Label>Assign to </Label>
                      <Input
                        id="forAssign"
                        type="select"
                        name="assigned_to_id"
                        required
                        //value={formData.assigned_to_id}
                       // onChange={handleChange}
                      >
                        <option value="">Select Assign to</option>
                        {
                          allTutors?.map((value,index)=>{
                            console.log("eeeee",value)
                            return(
                              <option value={value.mobile}>{value?.auth_user?.first_name}</option>
                            )
                          })
                        }
                      
                        
                      </Input>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mt-3">
                      <Label>Remark/Feedback (Internal)</Label>
                      <Input
                        type="textarea"
                        placeholder="Enter Remark/Feedback"
                        name="remark"
                        //value={formData.remark}
                        //onChange={handleChange}
                      />
                    </Col>
                    <Col md={6} className="mt-3">
                      <Label>Remark/Feedback (For tutor)</Label>
                      <Input
                        type="textarea"
                        placeholder="Enter Remark/Feedback"
                        name="tutor_remark[]"
                        //value={formData.tutor_remark}
                        //onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <div style={{ marginTop: "10px" }}>
                    <Row>
                      <Col md={12} style={{ float: "right" }}>
                        <Button
                          type="submit"
                          style={{
                            backgroundColor: "green",
                            color: "white",
                            float: "right",
                          }}
                        >
                          Qualified
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Col>
          </Row>
        </Card>

        <Modal isOpen={modal1} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            <h4> Edit Parent Details</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmiteditParentDetails}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Name </Label>
                    <Input
                      type="text"
                      placeholder="Enter Name"
                      name="first_name"
                     defaultValue={dataList?.userData?.
                      first_name}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Last Name</Label>
                    <Input
                      type="text"
                      placeholder="Enter Last Name"
                      name="last_name"
                      defaultValue={dataList?.userData?.
                        last_name}
                      
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email Address</Label>
                    <Input
                      type="text"
                      placeholder="Enter Email Address"
                      name="email"
                     defaultValue={dataList?.userData?.email}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mobile no</Label>
                    <Input
                      type="text"
                   
                      placeholder="Enter Mobile no"
                      disabled
                     defaultValue={dataList?.userData?.username
                     }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Gender</Label>
                    <Input
                      id="forType"
                      type="select"
                      name="gender"
                      value={selectedGender}
                      onChange={handleChangegender}
                    >
                      <option value="">Select Gender </option>
                      <option value="Male">Male</option>
                      <option value="FeMale">Female</option>
                      <option value="other">other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mode of Tuition</Label>

                    <Input
                      id="forType"
                      name="modeOfTution"
                      type="select"
                      defaultValue={dataList?.userData?.parentData?.modeOfTution}
                      onChange={handleChangeMode}
                    >
                      <option value="">Select Mode </option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">State</Label>
                    <Input
                      id="forType"
                      name="state"
                      type="text"
                      defaultValue={dataList?.userData?.parentData?.state}
                    >
                     
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Loaction</Label>
                    <Input
                      type="text"
                      placeholder="Enter Loaction"
                      name="location"
                      
                      defaultValue={dataList?.userData?.parentData?.location}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">City</Label>
                    <Input
                      id="forType"
                      name="city"
                      type="text"
                      defaultValue={dataList?.userData?.parentData?.city}
                    >
                     
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}

                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <Input type="date" className="mt-3" />
            <Input type="time" className="mt-3" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal2}>
                Cancel
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default QualifiedEnquiriesViewPage;
